<script lang="jsx">
  import StatelessCheck from '@xhs/yam-beer/cmp/dataEntry/Checkbox/StatelessCheckbox.vue'
  import Option from './Option.vue'

  // TODO: remove it.
  export default {
    name: 'CheckOption',
    props: {
      label: {},
      checked: {
        type: Boolean,
      },
      onChange: {
        type: Function,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      indeterminate: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { attrs, slots }) {
      const onCheckboxChange = (...args) => {
        if (props.onChange) {
          props.onChange(...args)
        }
      }

      return () => {
        const {
          label, checked, indeterminate, disabled,
        } = props
        return (
        <Option colorSvg={false} bs={{ py: 0 }} v-slots={slots}>
          <StatelessCheck
            {...attrs}
            bs={{
              display: 'flex',
              mr: 0,
            }}
            label={label}
            modelValue={checked}
            indeterminate={indeterminate}
            handleChange={onCheckboxChange}
            disabled={disabled}
          />
        </Option>
      )
      }
    },
  }
</script>
